import React from 'react';

import { Box, Skeleton, useTheme } from '@mui/material';

import { useStyles } from './CommunityProfileSkeleton.styles';

export default function CommunityProfileSkeleton() {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <>
      <Box className={classes.communityInfoWrapper}>
        <Skeleton
          variant="rounded"
          className={classes.avatar}
          animation="wave"
        />
        <Box className={classes.communityDetails}>
          <Box className={classes.info}>
            <Skeleton variant="text" width="42%" height={36} animation="wave" />
            <Skeleton variant="text" width="72%" height={26} animation="wave" />
            <Skeleton variant="text" width="64%" height={26} animation="wave" />
          </Box>
          <Box className={classes.actions}>
            <Skeleton
              variant="rounded"
              width={128}
              height={36}
              animation="wave"
            />
            <Skeleton
              variant="rounded"
              width={148}
              height={36}
              animation="wave"
            />
            <Skeleton
              variant="rounded"
              width={112}
              height={36}
              animation="wave"
            />
          </Box>
        </Box>
      </Box>
      <Box className={classes.detailsWrapper}>
        <Box className={classes.postsWrapper}>
          {[1, 2].map((item) => (
            <Box key={item} className={classes.cardContainer}>
              <Box className={classes.postHeader}>
                <Skeleton
                  variant="circular"
                  width={36}
                  height={36}
                  animation="wave"
                />
                <Box className={classes.postHeaderText}>
                  <Skeleton
                    variant="text"
                    width="55%"
                    height={22}
                    animation="wave"
                  />
                  <Skeleton
                    variant="text"
                    width="35%"
                    height={18}
                    animation="wave"
                  />
                </Box>
              </Box>
              <Skeleton
                variant="text"
                width="95%"
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="text"
                width="82%"
                height={24}
                animation="wave"
              />
              <Skeleton
                variant="rounded"
                className={classes.postMediaPlaceholder}
                animation="wave"
              />
              <Box className={classes.postFooter}>
                <Skeleton
                  variant="text"
                  width={56}
                  height={20}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={62}
                  height={20}
                  animation="wave"
                />
                <Skeleton
                  variant="text"
                  width={50}
                  height={20}
                  animation="wave"
                />
              </Box>
            </Box>
          ))}
        </Box>
        <Box className={classes.relationsWrapper}>
          <Box className={classes.cardContainer}>
            <Skeleton variant="text" width="56%" height={28} animation="wave" />
            <Box className={classes.relationList}>
              {[1, 2, 3].map((row) => (
                <Box key={row} className={classes.relationListRow}>
                  <Skeleton
                    variant="circular"
                    width={32}
                    height={32}
                    animation="wave"
                  />
                  <Skeleton
                    variant="text"
                    width="58%"
                    height={22}
                    animation="wave"
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
